import { Component, OnInit } from "@angular/core";
import { HttpUtilService } from "@services/http-util.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "@services/notifications.service";
import { environment } from "@env/environment";
import { ItemsService } from "@scaffold/services/items.service";
import { EnvironmentService } from "@services/environment.service";
import { TranslationService } from "@services/translation.service";

@Component({
  selector: "app-new-data",
  templateUrl: "./new-data.component.html",
  styleUrls: ["./new-data.component.scss"],
})
export class NewDataComponent implements OnInit {
  viewLoaded = false;

  type;
  create = {
    id: null,
    data: {},
  };

  create_info = {};
  create_data = {};

  opmPartners = [];
  partnerId = null;

  constructor(
    private translationService:TranslationService,
    private httpUtils: HttpUtilService,
    private route: ActivatedRoute,
    private router: Router,
    private notifications: NotificationsService,
    private itemsService: ItemsService,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.type = params.get("type");
      this.create_info = { type: this.type };

      if (this.environmentService.environment.isOPM) {
        this.httpUtils
          .authGet(this.environmentService.environment.apiRoot + "/institution/opm-partners")
          .subscribe((opmPartners) => {
            this.opmPartners = opmPartners;
          });
      }

      this.getCreateForm();
    });
  }

  private getCreateForm(partnerId = null) {
    let createUrl = `${this.environmentService.environment.apiRoot}/${this.type}/create`;
    if (partnerId != null) {
      createUrl += `?partnerId=${partnerId}`;
    }
    this.httpUtils.authGet(createUrl).subscribe((createForm) => {
      this.create = createForm;
      this.create.id = null;
      this.create_data = this.itemsService.getData({ type: this.type });
      console.log(this.create_data);
      this.viewLoaded = true;
    });
  }

  getNewView() {
    this.getCreateForm(this.partnerId);
  }

  hasErrors() {
    return this.itemsService.disableSave(this.type);
  }

  submitForm() {
    this.itemsService.hasAttemptedSave.next(true)
    // this.itemsService attempted save trigger errors 
    if (!this.hasErrors()) {
      delete this.create_data["data_input_error"];

      var postBody = {
        data: this.create_data,
        links: {},
        type: this.type,
      };
      let newDataPath = `${this.environmentService.environment.apiRoot}/${this.type}`;
      if (this.partnerId != null) {
        newDataPath += `?partnerId=${this.partnerId}`;
      }
      this.httpUtils
        .request("POST", newDataPath, postBody, null, true)
        .subscribe((newData) => {
          if (newData.errorMessage) {
            if (newData.errorType === "UsernameExistsException") {
              
              const text = this.translationService.getTranslatedContent('a_user_with_that_username_already_exists,_please_ensure_username_is_unique',"A user with that Username already exists, Please ensure Username is unique.")
              this.notifications.popNotification(
                text,
                "X",
                10
              );
            } else {
              const text = this.translationService.getTranslatedContent('there_was_an_issue_creating_a_new',"There was an issue creating a new")
              const endtext = this.translationService.getTranslatedContent('at_this_time._please_try_again_later._if_the_problem_persists_please_contact_an_administrator.',"There was an issue creating a new")

              this.notifications.popNotification(
                `${text} ` + this.translationService.getTranslatedContent(this.type) +" "+endtext,
                "X",
                5
              );
            }
          } else {
            // Reload the view so it's a new empty form
            this.itemsService.hasAttemptedSave.next(false)
            this.itemsService.resetNewData(this.type);
            this.viewLoaded = false;
            this.create_data = {};
            this.getCreateForm();
            if (this.type == "users" && newData.user_already_exists) {
              // Specific case for opm and partners
              
              const text = this.translationService.getTranslatedContent('this_user_now_has_access_to_this_scaffold_instance',"This user now has access to this scaffold instance.")
              this.notifications.popNotification(
                text,
                "X"
              );
            } else {
              this.notifications.popNotification(
                this.translationService.getTranslatedContent('new',"New") + this.translationService.getTranslatedContent(this.type,this.type) + " "+this.translationService.getTranslatedContent('created',"Created"),
                "X"
              );
            }
            //this.router.navigate(['/' + this.type]);
          }
        });
    }
  }
}
